/* FluffCo Coming Soon PDP — data-driven renderer + Klaviyo email capture.
 * Reads the config blob (keyed by product handle), renders the demand-test PDP,
 * and subscribes emails to the product's Klaviyo list via the client API. */
(function () {
  var CDN = '/cdn/shop/t/166/assets';
  var root = document.querySelector('[data-fc-cs-root]');
  if (!root) return;

  var handle = root.getAttribute('data-handle');
  var cfgEl = document.querySelector('[data-fc-cs-config]');
  var ALL = {};
  try { ALL = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  var P = ALL[handle];
  if (!P) { root.innerHTML = ''; return; }

  var KLAVIYO_KEY = window.FC_KLAVIYO_PUBLIC_KEY || '';

  // ── State ──────────────────────────────────────────────────────────────────
  var state = {
    variant: (P.variants && P.variants[0] && P.variants[0].id) || null,
    size:    (P.sizes && P.sizes[0] && P.sizes[0].id) || null,
    qty:     (P.quantities && P.quantities[0] && P.quantities[0].id) || '1',
    gallery: 0,
    openAcc: null,
    submitted: false,
    alreadyOnList: false,
    counterBase: P.seedCount || 247,
    autoTick: 0
  };
  // Restore prior signup for this product
  try {
    if (localStorage.getItem('fc_cs_signed_' + P.slug)) { state.submitted = true; state.alreadyOnList = true; }
  } catch (e) {}

  function esc(s) { return String(s == null ? '' : s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }
  function img(name) { return name.indexOf('http') === 0 ? name : CDN + '/' + name; }

  // ── Pricing ────────────────────────────────────────────────────────────────
  function activeVariant() { return P.variants ? P.variants.find(function (v) { return v.id === state.variant; }) : null; }
  function activeSize() { return P.sizes ? P.sizes.find(function (s) { return s.id === state.size; }) : null; }
  function sizeAdj() { var s = activeSize(); return (s && s.priceAdj) || 0; }
  function basePrice() { var v = activeVariant(); return (v && v.price != null) ? v.price : P.priceFrom; }
  function activePrice() { var b = basePrice(); return b != null ? b + sizeAdj() : null; }
  function strikePrice() {
    var v = activeVariant();
    if (v && v.strikePrice) return v.strikePrice + sizeAdj();
    var a = activePrice();
    return a ? Math.round(a * 1.4) : null;
  }
  function qtyPrice(q) {
    var v = activeVariant();
    if (v && v.quantityPrices && v.quantityPrices[q.id] != null) return v.quantityPrices[q.id] + sizeAdj();
    if (q.fixedPrice != null) return q.fixedPrice + sizeAdj();
    var a = activePrice();
    return a != null ? Math.round(a * q.multiplier) : null;
  }

  function stars(rating) {
    var out = '';
    for (var i = 1; i <= 5; i++) {
      out += '<svg width="13" height="13" viewBox="0 0 20 20" fill="' + (i <= Math.round(rating) ? '#ff808f' : '#e0d8d0') + '"><path d="M9.05 2.93c.3-.92 1.6-.92 1.9 0l1.07 3.29a1 1 0 00.95.69h3.46c.97 0 1.37 1.24.59 1.81l-2.8 2.03a1 1 0 00-.36 1.12l1.07 3.29c.3.92-.76 1.69-1.54 1.12l-2.8-2.03a1 1 0 00-1.18 0l-2.8 2.03c-.78.57-1.84-.2-1.54-1.12l1.07-3.29a1 1 0 00-.36-1.12l-2.8-2.03c-.78-.57-.38-1.81.59-1.81h3.46a1 1 0 00.95-.69l1.07-3.29z"/></svg>';
    }
    return '<span class="fc-cs__stars">' + out + '</span>';
  }

  function displayCount() { return (state.counterBase + state.autoTick + (state.submitted ? 1 : 0)).toLocaleString(); }

  // ── Render ───────────────────────────────────────────────────────────────────
  function render() {
    var price = activePrice();
    var strike = strikePrice();
    var savePct = (price && strike && strike > price) ? Math.round((1 - price / strike) * 100) : 0;
    var g = P.gallery || [];
    var gi = Math.min(state.gallery, g.length - 1);

    var html = '';
    html += '<div class="fc-cs__wrap">';

    // Breadcrumb
    html += '<nav class="fc-cs__crumb"><a href="/collections/coming-soon">← Coming Soon</a><span>/</span><strong>' + esc(P.name) + '</strong></nav>';

    html += '<div class="fc-cs__grid">';

    // Gallery
    html += '<div class="fc-cs__gallery">';
    html += '<div class="fc-cs__main">';
    html += '<span class="fc-cs__badge">Coming Soon</span>';
    html += '<img src="' + esc(img(g[gi])) + '" alt="' + esc((P.galleryAlt && P.galleryAlt[gi]) || P.name) + '">';
    if (g.length > 1) {
      html += '<button class="fc-cs__arrow fc-cs__arrow--l" data-cs-prev ' + (gi === 0 ? 'disabled' : '') + '>‹</button>';
      html += '<button class="fc-cs__arrow fc-cs__arrow--r" data-cs-next ' + (gi === g.length - 1 ? 'disabled' : '') + '>›</button>';
    }
    html += '</div>';
    if (g.length > 1) {
      html += '<div class="fc-cs__thumbs">';
      g.forEach(function (src, i) {
        html += '<button class="fc-cs__thumb' + (i === gi ? ' is-active' : '') + '" data-cs-thumb="' + i + '"><img src="' + esc(img(src)) + '" alt=""></button>';
      });
      html += '</div>';
    }
    html += '</div>';

    // Info column
    html += '<div class="fc-cs__info">';
    html += '<h1 class="fc-cs__title">' + esc(P.name) + '</h1>';
    html += '<div class="fc-cs__rating">' + stars(4.8) + '<span class="fc-cs__rating-num">4.8</span><span class="fc-cs__rating-sub">· FluffCo Brand Rating</span><span class="fc-cs__badge fc-cs__badge--inline">Coming Soon</span></div>';

    // Price
    html += '<div class="fc-cs__price-row">';
    html += '<span class="fc-cs__price">' + (price ? '$' + price : 'Price TBA') + '</span>';
    if (price && strike && savePct > 0) {
      html += '<span class="fc-cs__strike">$' + strike + '</span>';
      html += '<span class="fc-cs__save">Save ' + savePct + '%</span>';
    }
    html += '</div>';

    // Bullets
    html += '<div class="fc-cs__bullets">';
    (P.description.bullets || []).forEach(function (b) {
      html += '<div class="fc-cs__bullet"><svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M3 8.5L6.5 12L13 5" stroke="#4CAF50" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg><span>' + esc(b) + '</span></div>';
    });
    html += '</div>';

    // Variants — skip the picker entirely when there's only one variant (no choice to make).
    // The single variant remains the active state.variant set in init, so pricing/CTAs still resolve.
    if (P.variants && P.variants.length > 1) {
      html += '<div class="fc-cs__opt"><span class="fc-cs__opt-label">Style</span><div class="fc-cs__opt-grid" style="grid-template-columns:repeat(' + P.variants.length + ',1fr)">';
      P.variants.forEach(function (v) {
        html += '<button class="fc-cs__opt-btn' + (state.variant === v.id ? ' is-active' : '') + '" data-cs-variant="' + esc(v.id) + '"><span class="fc-cs__opt-name">' + esc(v.label) + '</span>' + (v.desc ? '<span class="fc-cs__opt-desc">' + esc(v.desc) + '</span>' : '') + '</button>';
      });
      html += '</div></div>';
    }

    // Sizes
    if (P.sizes && P.sizes.length) {
      html += '<div class="fc-cs__opt"><span class="fc-cs__opt-label">Size</span><div class="fc-cs__opt-grid" style="grid-template-columns:repeat(' + P.sizes.length + ',1fr)">';
      P.sizes.forEach(function (s) {
        html += '<button class="fc-cs__opt-btn' + (state.size === s.id ? ' is-active' : '') + '" data-cs-size="' + esc(s.id) + '"><span class="fc-cs__opt-name">' + esc(s.label) + '</span>' + (s.desc ? '<span class="fc-cs__opt-desc">' + esc(s.desc) + '</span>' : '') + '</button>';
      });
      html += '</div></div>';
    }

    // Quantity
    var qs = P.quantities || [{ id: '1', label: '1x', multiplier: 1 }, { id: '2', label: '2x', multiplier: 2 }];
    html += '<div class="fc-cs__opt"><span class="fc-cs__opt-label">How Many?</span><div class="fc-cs__opt-grid" style="grid-template-columns:repeat(' + qs.length + ',1fr)">';
    qs.forEach(function (q) {
      var qp = qtyPrice(q);
      html += '<button class="fc-cs__qty' + (state.qty === q.id ? ' is-active' : '') + '" data-cs-qty="' + esc(q.id) + '">';
      if (q.popular) html += '<span class="fc-cs__qty-pop">★ Most Popular' + (q.saveLabel ? ' · ' + esc(q.saveLabel) : '') + '</span>';
      html += '<span class="fc-cs__qty-label">' + esc(q.label) + '</span>';
      if (qp != null) html += '<span class="fc-cs__qty-price">$' + qp + '</span>';
      if (q.saveLabel && !q.popular) html += '<span class="fc-cs__qty-save">' + esc(q.saveLabel) + '</span>';
      html += '</button>';
    });
    html += '</div></div>';

    // Email capture
    html += '<div class="fc-cs__capture" data-cs-capture>';
    html += '<div class="fc-cs__urgency"><span class="fc-cs__pulse"></span><span>Launching soon — limited first-run inventory</span></div>';
    html += '<div class="fc-cs__counter">🔔 <strong>' + displayCount() + '</strong> people have already signed up</div>';
    if (state.submitted) {
      html += '<div class="fc-cs__success">' + (state.alreadyOnList ? "✓ You're already on the list!" : "✓ You're on the list! We'll notify you first.") + '</div>';
    } else {
      html += '<form class="fc-cs__form" data-cs-form><input type="email" required placeholder="Enter your email address" data-cs-email><p class="fc-cs__err" data-cs-err hidden></p><button type="submit" data-cs-submit>BE THE FIRST TO KNOW</button></form>';
    }
    html += '<p class="fc-cs__micro">No spam. Unsubscribe anytime.</p>';
    html += '</div>';

    // Trust
    html += '<div class="fc-cs__trust">';
    [['🌙','30-Night','Trial'],['🏨','Hotel','Quality'],['🔒','Secure','Checkout']].forEach(function (t) {
      html += '<div class="fc-cs__trust-item"><span>' + t[0] + '</span><strong>' + t[1] + '</strong><em>' + t[2] + '</em></div>';
    });
    html += '</div>';

    // Story
    html += '<div class="fc-cs__story"><p>' + esc(P.description.story) + '</p></div>';

    // Accordions
    html += '<div class="fc-cs__accs">';
    (P.accordions || []).forEach(function (a, i) {
      var open = state.openAcc === i;
      html += '<div class="fc-cs__acc"><button class="fc-cs__acc-head" data-cs-acc="' + i + '">' + esc(a.title) + '<span class="fc-cs__acc-plus' + (open ? ' is-open' : '') + '">+</span></button>';
      if (open) {
        html += '<div class="fc-cs__acc-body">';
        if (a.type === 'specs' && a.rows) {
          html += '<table class="fc-cs__specs">';
          a.rows.forEach(function (r) { html += '<tr><td>' + esc(r[0]) + '</td><td>' + esc(r[1]) + '</td></tr>'; });
          html += '</table>';
        } else {
          html += a.html || '';
        }
        html += '</div>';
      }
      html += '</div>';
    });
    html += '</div>';

    html += '</div>'; // info
    html += '</div>'; // grid
    html += '</div>'; // wrap
    root.innerHTML = html;

    // Cross-sells render into their own mount (placed after the press bar)
    var xsell = document.querySelector('[data-fc-cs-xsell]');
    if (xsell && P.crossSells && P.crossSells.length) {
      var x = '<div class="fc-cs__wrap"><div class="fc-cs__xsell"><h2>You Might Also Love</h2><div class="fc-cs__xsell-grid">';
      P.crossSells.forEach(function (c) {
        x += '<a class="fc-cs__xcard" href="' + esc(c.href) + '">';
        x += '<div class="fc-cs__xcard-img">';
        if (c.badge) x += '<span class="fc-cs__xbadge">' + esc(c.badge) + '</span>';
        x += '<img src="' + esc(img(c.image)) + '" alt="' + esc(c.name) + '" loading="lazy"></div>';
        x += '<div class="fc-cs__xcard-body"><p class="fc-cs__xname">' + esc(c.name) + '</p>';
        x += '<div class="fc-cs__xprice"><span>' + esc(c.price) + '</span>' + (c.originalPrice ? '<s>' + esc(c.originalPrice) + '</s>' : '') + '</div></div></a>';
      });
      x += '</div></div></div>';
      xsell.innerHTML = x;
    }

    bind();
  }

  // ── Events ─────────────────────────────────────────────────────────────────
  function bind() {
    root.querySelectorAll('[data-cs-thumb]').forEach(function (b) { b.onclick = function () { state.gallery = +b.getAttribute('data-cs-thumb'); render(); }; });
    var prev = root.querySelector('[data-cs-prev]'); if (prev) prev.onclick = function () { state.gallery = Math.max(0, state.gallery - 1); render(); };
    var next = root.querySelector('[data-cs-next]'); if (next) next.onclick = function () { state.gallery = Math.min((P.gallery.length - 1), state.gallery + 1); render(); };
    root.querySelectorAll('[data-cs-variant]').forEach(function (b) { b.onclick = function () { state.variant = b.getAttribute('data-cs-variant'); render(); }; });
    root.querySelectorAll('[data-cs-size]').forEach(function (b) { b.onclick = function () { state.size = b.getAttribute('data-cs-size'); render(); }; });
    root.querySelectorAll('[data-cs-qty]').forEach(function (b) { b.onclick = function () { state.qty = b.getAttribute('data-cs-qty'); render(); }; });
    root.querySelectorAll('[data-cs-acc]').forEach(function (b) { b.onclick = function () { var i = +b.getAttribute('data-cs-acc'); state.openAcc = state.openAcc === i ? null : i; render(); }; });

    var form = root.querySelector('[data-cs-form]');
    if (form) form.onsubmit = function (e) {
      e.preventDefault();
      var input = root.querySelector('[data-cs-email]');
      var errEl = root.querySelector('[data-cs-err]');
      var btn = root.querySelector('[data-cs-submit]');
      var email = (input.value || '').trim();
      if (!email) return;
      btn.disabled = true; btn.textContent = 'Signing up…';
      subscribe(email).then(function () {
        try { localStorage.setItem('fc_cs_signed_' + P.slug, '1'); } catch (e) {}
        state.submitted = true; state.alreadyOnList = false; render();
      }).catch(function () {
        if (errEl) { errEl.hidden = false; errEl.textContent = 'Something went wrong. Please try again.'; }
        btn.disabled = false; btn.textContent = 'BE THE FIRST TO KNOW';
      });
    };
  }

  // ── Klaviyo client-side list subscription ────────────────────────────────────
  function subscribe(email) {
    if (!KLAVIYO_KEY || !P.klaviyoListId) return Promise.reject();
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(KLAVIYO_KEY), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            profile: { data: { type: 'profile', attributes: {
              email: email,
              properties: { coming_soon_product: P.name, coming_soon_slug: P.slug }
            } } }
          },
          relationships: { list: { data: { type: 'list', id: P.klaviyoListId } } }
        }
      })
    }).then(function (r) {
      if (r.status === 202 || r.ok) return true;
      throw new Error('klaviyo ' + r.status);
    });
  }

  // ── Auto-increment counter (45–90s) ──────────────────────────────────────────
  (function tick() {
    var delay = Math.floor(Math.random() * 45000) + 45000;
    setTimeout(function () {
      state.autoTick++;
      var el = root.querySelector('.fc-cs__counter strong');
      if (el) el.textContent = displayCount();
      tick();
    }, delay);
  })();

  render();
})();
